var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasque(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Chantier/Casque/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3877,17 L17.9997,17 L17.9997,14 C17.9997,10.141 14.8597,7 10.9997,7 C7.1407,7 3.9997,10.141 3.9997,14 L3.9997,15 C3.9997,15.107 3.9827,15.214 3.9487,15.316 L3.3877,17 Z M21.9997,19 L1.9997,19 C1.6787,19 1.3767,18.846 1.1887,18.585 C1.0007,18.324 0.9497,17.988 1.0517,17.684 L1.9997,14.838 L1.9997,14 C1.9997,9.037 6.0367,5 10.9997,5 C15.9627,5 19.9997,9.037 19.9997,14 L19.9997,16.586 L20.4137,17 L21.9997,17 C22.5527,17 22.9997,17.447 22.9997,18 C22.9997,18.553 22.5527,19 21.9997,19 L21.9997,19 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15 C15.447,15 15,14.553 15,14 C15,11.794 13.206,10 11,10 C10.447,10 10,9.553 10,9 C10,8.447 10.447,8 11,8 C14.309,8 17,10.691 17,14 C17,14.553 16.553,15 16,15",
    id: "Fill-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasque);
export default __webpack_public_path__ + "static/media/casque.5092d9698e1067ccb019eecf26e54c1d.svg";
export { ForwardRef as ReactComponent };